export const regions = [
  {
    id: 1,
    name: "Greater Accra",
    value: "Greater Accra",
  },
  {
    id: 2,
    name: "Ashanti",
    value: "Ashanti",
  },
  {
    id: 3,
    name: "Western",
    value: "Western",
  },
  {
    id: 4,
    name: "Western North",
    value: "Western North",
  },
  {
    id: 5,
    name: "Central",
    value: "Central",
  },
  {
    id: 6,
    name: "Eastern",
    value: "Eastern",
  },
  {
    id: 7,
    name: "Northern",
    value: "Northern",
  },
  {
    id: 8,
    name: "Upper East",
    value: "Upper East",
  },
  {
    id: 9,
    name: "Upper West",
    value: "Upper West",
  },
  {
    id: 10,
    name: "Volta",
    value: "Volta",
  },
  {
    id: 11,
    name: "Oti",
    value: "Oti",
  },
  {
    id: 12,
    name: "Bono",
    value: "Bono",
  },
  {
    id: 13,
    name: "Bono East",
    value: "Bono East",
  },
  {
    id: 14,
    name: "Ahafo",
    value: "Ahafo",
  },
  {
    id: 15,
    name: "Western Region",
    value: "Western Region",
  },
  {
    id: 16,
    name: "Greater Accra Region",
    value: "Greater Accra Region",
  },
];


export const locationsByRegion = {
  'Greater Accra': [
    'Accra Central',
    'East Legon',
    'Osu',
    'Tema',
    'Madina',
    'Adenta',
    'Teshie',
    'Nungua',
    'Spintex',
    'Labadi',
    'Dansoman',
    'Kaneshie',
    'Darkuman',
    'Lapaz',
    'Achimota',
    'Airport Residential',
    'Cantonments',
    'Labone',
    'Ridge',
    'Roman Ridge'
  ],
  'Ashanti': [
    'Kumasi Central',
    'Adum',
    'Kejetia',
    'Bantama',
    'Nhyiaeso',
    'Asokwa',
    'Ahodwo',
    'Santasi',
    'Abrepo',
    'Manhyia',
    'Asafo',
    'Suame',
    'Tafo',
    'Kwadaso',
    'Patasi'
  ],
  'Western': [
    'Takoradi',
    'Sekondi',
    'Kwesimintsim',
    'Effiakuma',
    'New Takoradi'
  ],
  'Central': [
    'Cape Coast',
    'Kasoa',
    'Mankessim',
    'Winneba',
    'Elmina'
  ],
  'Eastern': [
    'Koforidua',
    'Nkawkaw',
    'Nsawam',
    'Asamankese',
    'Akropong'
  ],
  'Volta': [
    'Ho',
    'Hohoe',
    'Keta',
    'Aflao',
    'Kpando'
  ],
  'Northern': [
    'Tamale',
    'Yendi',
    'Savelugu',
    'Gushegu',
    'Karaga'
  ],
  'Upper East': [
    'Bolgatanga',
    'Navrongo',
    'Bawku',
    'Zebilla',
    'Tongo'
  ],
  'Upper West': [
    'Wa',
    'Lawra',
    'Jirapa',
    'Nandom',
    'Tumu'
  ],
  'Bono': [
    'Sunyani',
    'Berekum',
    'Dormaa Ahenkro',
    'Wenchi',
    'Techiman'
  ]
};